var _linearGradient, _path, _path2, _linearGradient2, _path3, _circle, _linearGradient3, _circle2, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e",
    gradientUnits: "userSpaceOnUse",
    x1: -5120.34,
    y1: -246.601,
    x2: -5119.34,
    y2: -246.601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M102.861 80.538h45.155M102.861 95.684h31.397M102.861 102.525h25M107.892 44.173h60.55v77.687H29.894V44.173H89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M102.982 65.182h52.958v7.843h-52.958zM42.289 56.367h47.48v53.403h-47.48z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e",
    gradientUnits: "userSpaceOnUse",
    x1: 88.378,
    y1: 34.566,
    x2: 108.467,
    y2: 34.566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.423 53.255h0a8.795 8.795 0 01-8.795-8.795V24.672a8.795 8.795 0 018.795-8.795h0a8.795 8.795 0 018.795 8.795V44.46a8.796 8.796 0 01-8.795 8.795z",
    fill: "none",
    stroke: "url(#SVGID_1_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 98.388,
    cy: 44.099,
    r: 3.618
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e",
    gradientUnits: "userSpaceOnUse",
    x1: 54.225,
    y1: 81.289,
    x2: 77.322,
    y2: 81.289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.773,
    cy: 81.289,
    r: 10.298,
    fill: "none",
    stroke: "url(#SVGID_2_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e",
    gradientUnits: "userSpaceOnUse",
    x1: 46.797,
    y1: 99.645,
    x2: 84.75,
    y2: 99.645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.047 107.699c.859-9.038 8.47-16.107 17.733-16.107 9.218 0 16.801 7.002 17.72 15.977",
    fill: "none",
    stroke: "url(#SVGID_3_3130cbf42264d1c0854a65f38937eb1b1997d8b25e6faf29eb7ba208f9dd361e)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralRoles);
export default __webpack_public_path__ + "static/media/generalRoles.e799c279928af6acb9553eec771eb4de.svg";
export { ForwardRef as ReactComponent };